import { render, staticRenderFns } from "./intercom.vue?vue&type=template&id=29635e96"
import script from "./intercom.vue?vue&type=script&lang=js"
export * from "./intercom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29635e96')) {
      api.createRecord('29635e96', component.options)
    } else {
      api.reload('29635e96', component.options)
    }
    module.hot.accept("./intercom.vue?vue&type=template&id=29635e96", function () {
      api.rerender('29635e96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/intercom.vue"
export default component.exports